import React, { useEffect, useState } from "react";
import orange from "@mui/material/colors/orange";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Fonts } from "../../../../../shared/constants/AppEnums";
import { getRoles } from "../../../../../redux/actions/Master";
import { AppState } from "../../../../../redux/store";
import { useAuthMethod, useAuthUser } from "@crema/utility/AuthHooks";

interface UserInfoProps {
  color?: string;
}

const UserInfo: React.FC<UserInfoProps> = ({ color = "text.secondary" }) => {
  const { logout } = useAuthMethod();
  const dispatch = useDispatch();
  const { user } = useAuthUser();
  const roles = useSelector((state: AppState) => state.master.roles);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [username, setUsername] = useState<string>("Comway User");
  const [role, setRole] = useState<string>("N/A");

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const firstLetterCapital = (text: string): string => {
  if (!text) return text;
  const firstChar = text.charAt(0);
  if (firstChar === firstChar.toUpperCase()) {
    return text;
  }
  return firstChar.toUpperCase() + text.slice(1).toLowerCase();
};



  const getUserAvatar = () => {
    if (user.displayName) {
      return user.displayName.charAt(0).toUpperCase();
    }
    if (user.email) {
      return user.email.charAt(0).toUpperCase();
    }
    return "U";
  };

  useEffect(() => {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      const parsedData = JSON.parse(userInfo);
      const capitalizedUsername = parsedData.username
      ? firstLetterCapital(parsedData.username)
      : "Comway User";
    setUsername(capitalizedUsername);;
      dispatch(getRoles());
    }
  }, [dispatch]);

  useEffect(() => {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo && roles.length > 0) {
      const parsedData = JSON.parse(userInfo);
      const userRole = roles.find((role) => role.id === parsedData.roleId);
      setRole(userRole ? userRole.role : "N/A");
    }
  }, [roles]);

  return (
  <>
  <Box
    onClick={handleClick}
    sx={{
      py: 3,
      px: 3,
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    }}
    className="user-info-view"
  >
    {/* Avatar */}
    <Box sx={{ py: 0.5 }}>
      {user.photoURL ? (
        <Avatar
          src={user.photoURL}
          sx={{
            height: 40,
            width: 40,
            fontSize: 24,
            backgroundColor: orange[500],
          }}
        />
      ) : (
        <Avatar
          sx={{
            height: 40,
            width: 40,
            fontSize: 24,
            backgroundColor: orange[500],
          }}
        >
          {getUserAvatar()}
        </Avatar>
      )}
    </Box>

    {/* Username and Role */}
    <Box
      sx={{
        flex: 1, // Let it grow to available space
        ml: 2,
        minWidth: 0, // IMPORTANT for text ellipsis inside flex
        color: color,
      }}
      className="user-info"
    >
      {/* Name + Icon Row */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: 16,
            fontWeight: Fonts.MEDIUM,
            color: 'inherit',
          }}
          component="span"
        >
          {username}
        </Box>

        <ExpandMoreIcon sx={{ fontSize: 20, color: 'inherit' }} />
      </Box>

      {/* Role */}
      <Box
        sx={{
          fontSize: 13,
          mt: 0.2,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          color: 'text.secondary',
        }}
      >
        {role}
      </Box>
    </Box>
  </Box>

  {/* Dropdown Menu */}
  <Menu
    id="simple-menu"
    anchorEl={anchorEl}
    keepMounted
    open={Boolean(anchorEl)}
    onClose={handleClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
  >
    <MenuItem onClick={logout}>Logout</MenuItem>
  </Menu>
</>

  );
};

export default UserInfo;
